import { FeatureTypes } from "entity-app/constants";
import Milestone from "./components/milestone";
import "./index.scss";

function WorkflowTemplateBulkEditor(props: {
  disabled: boolean;
  milestonesState: any;
  floatState: any;
  featureType: FeatureTypes;
}) {
  const { disabled, milestonesState, floatState, featureType } = props;

  const [float, setFloat] = floatState;
  const [milestones, setMilestones] = milestonesState;

  const onMilestoneValueChange = (data: any) => {
    const clonedMilestoneState: any = [...milestones];
    clonedMilestoneState[data.milestone_index] = {
      ...milestones[data.milestone_index],
      value: data.value
    };
    setMilestones(clonedMilestoneState);
  };

  return (
    <div
      className="w-full workflow-template-bulk-editor overflow-x-auto"
      data-testid="workflow-template-bulk-editor"
    >
      <div className="flex w-full" data-testid="milestones-list">
        {milestones.map((t: any, index: number) => (
          <Milestone
            allMilestones={milestones}
            onMilestoneValueChange={onMilestoneValueChange}
            key={t.id}
            index={index}
            milestone={t}
            disable={disabled}
            floatState={{ float, setFloat }}
            featureType={featureType}
            data-testid={`milestone-${index}`}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkflowTemplateBulkEditor;
